export function getQuery(query) {
  return query || ''
}
